var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-tabs",
    { attrs: { animated: false, "default-active-key": "1" } },
    [
      _c(
        "a-tab-pane",
        { key: "1" },
        [
          _c("span", { attrs: { slot: "tab" }, slot: "tab" }, [
            _vm._v(" Chat "),
          ]),
          _vm._v(" "),
          _vm._t("privateChatRepresentativeSlot"),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "a-tab-pane",
        { key: "2" },
        [
          _c("span", { attrs: { slot: "tab" }, slot: "tab" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("message.representative")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("PrivateChatRepresentative"),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-tab-pane", { key: "3" }, [
        _c("span", { attrs: { slot: "tab" }, slot: "tab" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("message.settings")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-3 d-flex align-items-center" },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("message.privateChatNotificationSound"))),
            ]),
            _vm._v(" "),
            _c(
              "md-switch",
              {
                staticClass: "md-primary ml-3",
                model: {
                  value: _vm.privateChatIsMutedComputed,
                  callback: function ($$v) {
                    _vm.privateChatIsMutedComputed = $$v
                  },
                  expression: "privateChatIsMutedComputed",
                },
              },
              [
                !_vm.privateChatIsMuted
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("message.active")))])
                  : _c("span", [_vm._v(_vm._s(_vm.$t("message.passive")))]),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }